import { render, staticRenderFns } from "./WebPartFormShopWithProductDesigner.vue?vue&type=template&id=61e9d50a&scoped=true&"
import script from "./WebPartFormShopWithProductDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormShopWithProductDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartFormShopWithProductDesigner.vue?vue&type=style&index=0&id=61e9d50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e9d50a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e9d50a')) {
      api.createRecord('61e9d50a', component.options)
    } else {
      api.reload('61e9d50a', component.options)
    }
    module.hot.accept("./WebPartFormShopWithProductDesigner.vue?vue&type=template&id=61e9d50a&scoped=true&", function () {
      api.rerender('61e9d50a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartFormShopWithProductDesigner.vue"
export default component.exports